import { render, staticRenderFns } from "./CoHumanVerification.vue?vue&type=template&id=9e340560&scoped=true&"
import script from "./CoHumanVerification.vue?vue&type=script&lang=ts&"
export * from "./CoHumanVerification.vue?vue&type=script&lang=ts&"
import style0 from "./CoHumanVerification.vue?vue&type=style&index=0&id=9e340560&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e340560",
  null
  
)

export default component.exports